import dayjs from 'dayjs';

export const dashboard = (mode) => ({
  data: () => ({
    mode: mode,
    selectedDates: '',
    hasSelected: false,
    currentUnformattedTime: '',
    currentTimestamp: '',
    currentTime: '',
    timestampStart: '',
    timestampEnd: '',
    test: '',
    hasSet: false,
  }),
  watch: {
    selectedDates() {
      if (this.hasSet) {
        this.selectDates();
      }
    },
  },
  computed: {
    todaysFormattedDate() {
      return dayjs(this.currentUnformattedTime).format('DD MMMM YYYY');
    },
    formattedTimestampStart() {
      return dayjs.unix(this.timestampStart).format('DD MMMM');
    },
    formattedTimestampEnd() {
      return dayjs.unix(this.timestampEnd).format('DD MMMM YYYY');
    },
    dateRange() {
      if (!this.hasSelected) {
        return `${ this.todaysFormattedDate }`
      } else {
        return `${ this.formattedTimestampStart } - ${ this.formattedTimestampEnd }`;
      }
    },
    isDarkMode() {
      return this.$store.state.mode.darkMode;
    },
    currentOrg() {
      return this.$route.query.org ? this.$route.query.org : '';
    },
    status() {
      const status = this.$route.query.q ? this.$route.query.q : '*';
      switch (status) {
        case 'success': return 0;
        case 'error': return 1;
        case 0: return 0;
        case 1: return 1;
      }
      return '*';
    }
  },
  methods: {
    selectDates() {
      const formattedTimestampStart = dayjs(this.selectedDates.start).unix();
      const formattedTimestampEnd = dayjs(this.selectedDates.end).unix()+86399;

      this.timestampStart = formattedTimestampStart;
      this.timestampEnd = formattedTimestampEnd;
      this.currentUnformattedTime = this.selectedDates.start;
      this.hasSelected = true;
      this.updateData();
    },
    selectRangeDate() {
      this.hasSet = true;
    },
    goNextHour() {
      this.timestampStart = this.timestampStart + 3600000;
      this.timestampEnd = this.timestampEnd + 3600000;
    },
    goPrevHour() {
      this.timestampStart = this.timestampStart - 3600000;
      this.timestampEnd = this.timestampEnd - 3600000;
    },
    updateData() {

    },
    selectDate(dateType) {
      switch (dateType) {
        case "day": {
          this.currentUnformattedTime = dayjs(this.currentUnformattedTime).subtract(1, 'd');
          this.timestampStart = this.timestampStart - 86400;
          const newStartDate = dayjs.unix(this.timestampStart).$d;
          const newStartDateTimestamp = dayjs(newStartDate).unix();

          this.selectedDates.start = newStartDate;
          this.timestampStart = newStartDateTimestamp;
          this.$refs.calendar.$data.inputValue =  `${this.formattedTimestampStart} - ${this.formattedTimestampEnd}`;
          this.updateData();
          break;
        }
        case "week": {
          this.currentUnformattedTime = dayjs(this.currentUnformattedTime).subtract(1, 'd');
          this.timestampStart = this.timestampStart - 604800;
          const newStartDate = dayjs.unix(this.timestampStart).$d;
          const newStartDateTimestamp = dayjs(newStartDate).unix();

          this.selectedDates.start = newStartDate;
          this.timestampStart = newStartDateTimestamp;

          this.updateData();
          break;
        }
        default: {
          break;
        }
      }
    },
  },
  created() {
    // Global current time in date format & timestamp
    this.currentUnformattedTime = dayjs();
    this.currentTimestamp = this.currentUnformattedTime.unix();

    // Set both timestamps
    if (mode === 'home') {
      this.timestampStart = this.currentUnformattedTime.unix() - 3600000;
      this.timestampEnd = this.currentUnformattedTime.unix();
    }

    if (mode !== 'home') {
      this.timestampStart = Number(this.$route.query.f);
      this.timestampEnd = Number(this.$route.query.t);
    }

    // Format timestamps into accetable v-calendar format
    const start = dayjs.unix(this.timestampStart).$d;
    const end = dayjs.unix(this.timestampEnd).$d;
    const dateRange = {
      start,
      end,
    };

    this.hasSelected = true;
    this.selectedDates = dateRange;
  },
});
